<!-- src/ChapterPagePart1Content.vue -->
<!-- Shows every page of one chapter, top to bottom, with the chapter nav bar above and below -->

<template>
  <div v-if="loading" class="text-center p-4 textmain d-flex align-items-center justify-content-center">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-else-if="error" class="text-center p-4">
    <p class="text-danger">{{ error }}</p>
    <router-link to="/chapters" class="textmain textmainhover">Back to chapters</router-link>
  </div>
  <div v-else-if="chapter" class="container chapter-reader py-3">
    <ChapterNavBar :chapters="chapters" :currentChapter="chapterNumber" />

    <header class="dark-gray-box-1 text-center p-3 mt-3">
      <h1 class="textmain MainTitleFont m-0">Chapter {{ chapter.ChapterNumber }}</h1>
      <h2 v-if="chapter.Name" class="subTitleFont textwhite mt-1">{{ chapter.Name }}</h2>
      <p v-if="chapter.Description" class="textlightgray mb-1">{{ chapter.Description }}</p>
      <small class="textlightgray">{{ formatChapterDate(chapter.Date) }}</small>
    </header>

    <div class="d-flex flex-column align-items-center mt-3">
      <img
        v-for="(url, page) in pageUrls"
        :key="url"
        :src="url"
        :alt="`Chapter ${chapter.ChapterNumber}, page ${page}`"
        :loading="page < 2 ? 'eager' : 'lazy'"
        class="chapter-page-image"
      >
    </div>

    <ChapterNavBar class="mt-3" :chapters="chapters" :currentChapter="chapterNumber" />
  </div>
</template>

<style scoped>
.chapter-reader {
  max-width: 900px;
}
.chapter-page-image {
  width: 100%;
  height: auto;
  display: block;
}
</style>

<script>
import ChapterNavBar from '@/ChapterNavBar.vue';
import { fetchChapters, fetchChapter, chapterPageUrls, formatChapterDate } from '@/chapterApi.js';

export default {
  name: 'ChapterPagePart1Content',
  components: {
    ChapterNavBar,
  },
  props: {
    id: [String, Number], // ChapterNumber from the route
  },
  data() {
    return {
      chapter: null,
      chapters: [], // every chapter, for the nav bar
      loading: true,
      error: null,
    };
  },
  computed: {
    chapterNumber() {
      return Number(this.id);
    },
    pageUrls() {
      return this.chapter ? chapterPageUrls(this.chapter) : [];
    },
  },
  watch: {
    // Previous/next/dropdown reuse this component, so reload when the chapter changes
    id: {
      immediate: true,
      handler() {
        this.loadChapter();
      },
    },
  },
  methods: {
    formatChapterDate,
    async loadChapter() {
      this.loading = true;
      this.error = null;
      try {
        const [chapter, chapters] = await Promise.all([
          fetchChapter(this.id),
          this.chapters.length ? this.chapters : fetchChapters(),
        ]);
        this.chapter = chapter;
        this.chapters = chapters;
        document.title = `Sins of Dissentia - Chapter ${chapter.ChapterNumber}` + (chapter.Name ? `: ${chapter.Name}` : '');
        window.scrollTo(0, 0);
      } catch (error) {
        console.error('Error fetching chapter:', error);
        this.error = error.message || 'Could not load chapter';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
